import { matchPath } from "react-router-dom";
import { routesWithSidebar } from "../route/Routes";
import { DASHBOARD, FORBIDDEN } from "../route/paths";

export const checkRoutePermission = (
  pathname,
  userPermissions,
  isfullAccess
) => {
  const allowedRoutes = [FORBIDDEN, DASHBOARD];
  if (allowedRoutes.includes(pathname)) {
    return true;
  }

  // Full access bypass
  if (isfullAccess) {
    return true;
  }

  // Find current route. matchPath with end:false is a prefix match, so a
  // pathname like /admin/banner-notifications/create matches both the list
  // route and the create route. Pick the most specific match (most path
  // segments) so each page resolves to its own permission rather than the
  // first-declared prefix.
  const countSegments = (path) => path.split("/").filter(Boolean).length;
  const matchedRoute = routesWithSidebar
    .filter(
      (route) =>
        route.path && matchPath({ path: route.path, end: false }, pathname)
    )
    .sort((a, b) => countSegments(b.path) - countSegments(a.path))[0];

  // Route not found
  if (!matchedRoute) {
    return true;
  }

  const requiredPermissions = matchedRoute.permissions || [];

  // Strict mode:
  // No permissions configured = forbidden
  if (requiredPermissions.length === 0) {
    return false;
  }

  // User must have at least one permission
  return requiredPermissions.some((permission) =>
    userPermissions.includes(permission)
  );
};
